import React, { useState } from 'react';
import { Form, Formik, Field } from "formik";
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Errors } from '../../common';
import { connect } from 'react-redux';
import geometricElements from '..';
import InternationalizationRender, { getInternationalization, PARAMETER_ELEMENT_TEXT_PLURAL, PARAMETER_ELEMENT_TEXT_SINGULAR } from '../../app/components/InternationalizationRender';
import app from '../../app';

const mapStateToProps = function (state) {
    return ({
        language: app.selectors.getLanguage(state),
        activeLanguages: app.selectors.getActiveLanguages(state),
        allCodes: geometricElements.selectors.getAllCodes(state)
    });
}

const ClearGeometricElementType = ({ modalShow, handleSubmit, hideModalWindow, geometricElementType, backendErrors, setBackendErrors, ...props }) => {

    const [removedElements, setRemovedElements] = useState(null);

    if (modalShow) {

        const initialValues = {
            minId: '',
            maxId: ''
        }

        return (
            <Formik
                initialValues={initialValues}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={(values, { setSubmitting }) => {

                    setBackendErrors(null);

                    props.dispatch(geometricElements.actions.emptyGeometricElementType({
                        geometricElementTypeId: geometricElementType.id,
                        minId: values.minId,
                        maxId: values.maxId
                    }, (total) => {

                        setRemovedElements(total);
                    }, errors => {

                        setBackendErrors(errors)
                    }));

                    setSubmitting(false);
                }}
            >
                {({ resetForm }) =>
                    <Modal backdrop="static" show={modalShow} onHide={hideModalWindow} scrollable={true} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <FormattedHTMLMessage id="project.elements.clear.title" values={{
                                    element: getInternationalization(props.language, geometricElementType.code, props.allCodes, props.activeLanguages)
                                }} />
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form className="needs-validation novalidate" id="emptyGeometricElementTypeForm">
                                {removedElements != null && <div className="alert alert-success" role="alert">
                                    <FormattedMessage id="project.elements.clear.confirmation" values={{
                                        total: removedElements,
                                        plural: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_PLURAL} />
                                    }} />
                                </div>}

                                {removedElements == null &&
                                    <>
                                        <Errors errors={backendErrors} onClose={() => setBackendErrors(null)} />

                                        <div class="alert alert-warning" role="alert">
                                            <FormattedMessage id="project.elements.clear.alert" values={{
                                                plural: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_PLURAL} />
                                            }} />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="minId" className="font-weight-bold">
                                                <FormattedMessage id="project.elements.clear.minId" values={{
                                                    singular: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_SINGULAR} />
                                                }} />
                                            </label>
                                            <Field type="number" id="minId"
                                                name="minId" className="form-control"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="maxId" className="font-weight-bold">
                                                <FormattedMessage id="project.elements.clear.maxId" values={{
                                                    singular: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_SINGULAR} />
                                                }} />
                                            </label>
                                            <Field type="number" id="maxId"
                                                name="maxId" className="form-control"
                                            />
                                        </div>
                                    </>}
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            {removedElements == null &&
                                <>
                                    <button id="emptyGeometricElementTypeSubmit"
                                        type="submit"
                                        className="btn btn-primary"
                                        form="emptyGeometricElementTypeForm"
                                    >
                                        <FormattedMessage id="project.app.Body.accept" />
                                    </button>
                                    <button id="emptyGeometricElementTypeCancel"
                                        onClick={() => {
                                            resetForm({
                                                minId: '',
                                                maxId: ''
                                            });
                                            hideModalWindow();
                                        }}
                                        type="cancel"
                                        className="btn btn-danger"
                                    >
                                        <FormattedMessage id="project.app.Body.cancel" />
                                    </button>
                                </>}
                            {removedElements != null &&
                                <button id="emptyGeometricElementTypeConfirmationButton"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        resetForm({
                                            minId: '',
                                            maxId: ''
                                        });
                                        handleSubmit();
                                        setRemovedElements(null);
                                    }}
                                >
                                    <FormattedMessage id="project.common.close" />
                                </button>
                            }
                        </Modal.Footer>
                    </Modal>
                }
            </Formik>
        );
    }

    return null;
}

ClearGeometricElementType.propTypes = {
    modalShow: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    hideModalWindow: PropTypes.func.isRequired,
    geometricElementId: PropTypes.number.isRequired,
    backendErrors: PropTypes.object,
    setBackendErrors: PropTypes.func.isRequired
}

export default connect(mapStateToProps)(ClearGeometricElementType);